module.exports = __webpack_public_path__ + "static/media/TryOn.03b2ad9f.svg";